import axios from "axios"
import {getApiStatus, getAppStatus} from "@/data/repos/appStatus"
import {getTestData} from "@/data/repos/mockDataLoader"

// This file loads configuration from .env.xxx files if rendered on server
// and from public/config/config.json while running in browser.
// IRL when this app is served as a static assets
// file public/config/config.json will be shadowed by configMap mounted over it.

export const status: { [key: string]: boolean } = {
  loaded: false,
}

interface Config {
  [key: string]: string
}

const config: Config = {
  BASE_URL: process.env.VUE_APP_BASE_URL,
  BASE_API_URL: process.env.VUE_APP_BASE_URL,
  AUTH_URL: process.env.VUE_APP_AUTH_URL,
  AUTH_CALLBACK_URL: process.env.VUE_APP_AUTH_CALLBACK_URL,
  AUTH_API_URL: process.env.VUE_APP_AUTH_API_URL,
  AUTH_LOGOUT_URL: process.env.VUE_APP_AUTH_LOGOUT_URL,
  IPR_BASE_URL: process.env.VUE_APP_IPR_BASE_URL,
  AUDIT_BASE_URL: process.env.VUE_APP_AUDIT_BASE_URL,
}
export default config

export async function retrieveConfig() {
  const rnd = Math.random().toString().slice(2)
  const url = `/config/config.json?v=${rnd}`
  if (process.env.NODE_ENV === "test") {
    Object.assign(config, await getTestData("config") as Config)
    return true
  }
  // noinspection ES6MissingAwait
  try {
    const r = await axios.get(url)
    Object.assign(config, r.data as Config)
    checkConfig()
    status.loaded = true
    console.log("Loaded config")
    return true
  } catch (err) {
    console.error(`Failed to load configuration from ${url}`)
    console.error(err)
    return false
  }
}

function checkConfig() {
  for (const key in config) {
    if (!config[key]) {
      console.error("Configuration key is missing:", key)
    }
  }
}

export async function getVersions() {
  if (process.env.NODE_ENV === "test") {
    return
  }
  const appResp = await getAppStatus()
  const apiResp = await getApiStatus()
  const versions = {APP_VERSION: "", API_VERSION: ""}
  if (appResp) {
    console.log("App version:", appResp.version)
    versions.APP_VERSION = appResp.version
  }
  if (appResp) {
    console.log("API version:", apiResp.version)
    versions.API_VERSION = apiResp.version
  }
  return versions
}
